import React, { useEffect, useState } from 'react'

import { connect } from 'react-redux'
import ExploringMap from '../../Exploring/ExploringMap'
import { fetchData } from '../../../common/redux/collectionActions'
import { groupBy } from '../../../common/utils'

type Props = {
  fetchLocks: Function,
  locks: [{}],
}

const testRegex = /test|demo/i

const ExploringContainer = ({ fetchLocks, locks }: Props) => {
  const [selectedLock, setSelectedLock] = useState()
  const [search, setSearch] = useState('')

  useEffect(() => {
    if (!locks.length) fetchLocks()
  }, [locks.length])

  const selectLock = (lockId) => {
    if (selectedLock === lockId) {
      setSelectedLock()
    } else {
      setSelectedLock(lockId)

      const lockEl = document.getElementById(lockId)
      lockEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })

      lockEl.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'

      setTimeout(() => {
        lockEl.style.boxShadow = 'none'
      }, 3000)
    }
  }

  const renderCity = ([key, ls]) => (
    <div key={key}>
      <h4>{key}</h4>
      {ls
        .filter((l) => {
          const parsedSearch = search.toLowerCase()

          const { street, city, zip } = l.address

          try {
            return l.custom_name.toLowerCase().includes(parsedSearch) || street.toLowerCase().includes(parsedSearch) || city.toLowerCase().includes(parsedSearch) || zip.includes(parsedSearch)
          } catch (e) {
            console.error(l)
            return false
          }
        })
        .sort((a, b) => (a.custom_name > b.custom_name ? 1 : -1))
        .map((l) => (
          <div style={{ border: '1px solid lightgrey', borderRadius: 3, padding: '20px 0' }} key={l._id} id={l._id}>
            {`${l.custom_name}, ${l.address.street}, ${l.address.zip}`}
          </div>
        ))}
    </div>
  )

  const sortedLocks = [...locks.entries()].sort(([, lsA], [, lsB]) => lsB.length - lsA.length)

  const swedenLocks = sortedLocks.filter(([, ls]) => !ls[0].countryCode).map(renderCity)
  const norwayLocks = sortedLocks.filter(([, ls]) => ls[0].countryCode === '47').map(renderCity)

  return (
    <div>
      {locks.size > 0 && <ExploringMap locks={[...locks.values()].flat()} isAdmin={false} selectLock={selectLock} />}
      <div style={{ background: '#fff', padding: 10, borderRadius: 10, width: window.isMobile ? '100%' : '33%' }}>
        <input placeholder="&#128269; Sök på stad, gata eller postnummer" style={{ border: 'none', borderBottom: '2px solid lightgrey', width: '100%', textAlign: 'center' }} type="text" onInput={(e) => setSearch(e.target.value)} />
      </div>
      {swedenLocks}
      <br />
      {norwayLocks.length > 0 && <h3>Norge</h3>}
      {norwayLocks}
    </div>
  )
}

const mapState = (state) => ({
  locks: groupBy([...state.collectionData.locks].filter((l) => !testRegex.test(l.custom_name) && !testRegex.test(l.address.street)), (l) => l.address.city),
})

const mapDispatch = (dispatch) => ({
  fetchLocks: () => dispatch(fetchData(['locks'])),
})

const checkDiff = (prevProps, nextProps) => prevProps.locks?.size === nextProps.locks?.size

export default connect(
  mapState,
  mapDispatch
)(React.memo(ExploringContainer, checkDiff))
